import React from 'react';
import ReactPlayer from 'react-player/lazy';
import PropTypes from 'prop-types';

const ArticleVideo = ({ video }) => {
  const [play, setPlay] = React.useState(false);
  return (
    <div className="article-video">
      <div
        className={
          play ? 'article-player__owerlay is-play' : 'article-player__owerlay'
        }
        role="presentation"
        onClick={() => setPlay(true)}
      ></div>
      <div className="article-player__wrapper">
        {video ? (
          <ReactPlayer
            className="react-player"
            playing={play}
            controls={true}
            url={video}
            width="100%"
            height="100%"
            config={{
              youtube: {
                playerVars: { origin: 'http://localhost:8000' },
              },
            }}
          />
        ) : null}
      </div>
    </div>
  );
};

ArticleVideo.propTypes = {
  video: PropTypes.string,
};

export default ArticleVideo;
